<template>
  <v-container style="width: 600px; height: 550px">
    <v-card class="flex-with-image" elevation="4" light tag="section">
      <v-flex class="d-flex justify-end">
        <v-btn class="mt-3 no-underline" text large @click="$emit('goLogin')">
          <v-icon color="white" class="display-2" left>mdi-close</v-icon>
        </v-btn>
      </v-flex>
      <v-card-title>
        <v-flex class="d-flex justify-center align-center">
          <span class="white--text text-center text-h4 ma-10"
            >Восстановление пароля</span
          >
        </v-flex>
      </v-card-title>

      <v-stepper v-model="step">
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form @submit.prevent="requestReset">
              <v-text-field
                v-model="email"
                label="Email"
                required
                solo
              ></v-text-field>
              <v-btn type="submit" color="primary">Отправить код</v-btn>
            </v-form>
            <div v-if="message">{{ message }}</div>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form @submit.prevent="resetPassword">
              <v-text-field
                v-model="token"
                label="Код подтверждения"
                required
                solo
                autocomplete="off"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Новый пароль"
                :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNewPassword ? 'text' : 'password'"
                @click:append="showNewPassword = !showNewPassword"
                required
                solo
                autocomplete="new-password"
              ></v-text-field>
              <v-text-field
                v-model="passwordConfirm"
                label="Повторить новый пароль"
                :append-icon="
                  showNewPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'
                "
                :type="showNewPasswordConfirm ? 'text' : 'password'"
                @click:append="showNewPasswordConfirm = !showNewPasswordConfirm"
                required
                solo
                autocomplete="new-password"
              ></v-text-field>
              <v-btn type="submit" color="primary">Сменить пароль</v-btn>
            </v-form>
            <div v-if="message">{{ message }}</div>
          </v-stepper-content>

          <v-stepper-content step="3">
            <div class="text-center">
              <h2>Пароль успешно изменен!</h2>
              <v-btn @click="$emit('goLogin')">Вернуться ко входу</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-container>
</template>

<script>
import NSApi from "@/api/NSApi";

export default {
  name: "RecoverForm",
  data() {
    return {
      step: 1,
      email: "",
      token: "",
      password: "",
      passwordConfirm: "",
      message: "",
      showNewPassword: false,
      showNewPasswordConfirm: false,
    };
  },
  created() {
    const urlToken = this.$route.query.token;
    const urlEmail = this.$route.query.email;
    if (urlToken) {
      this.token = urlToken;
      this.email = urlEmail;
      this.step = 2;
    }
  },
  methods: {
    async requestReset() {
      this.message = "";
      try {
        await NSApi.instance.requestPasswordReset(this.email);
        this.message = "Письмо с кодом отправлено на ваш email.";
        this.step = 2;
      } catch (error) {
        this.message = error.response?.data?.message || "Произошла ошибка";
      }
    },
    async resetPassword() {
      this.message = "";
      if (this.password !== this.passwordConfirm) {
        this.message = "Пароли не совпадают";
        return;
      }

      try {
        await NSApi.instance.resetPassword(
          this.email,
          this.token,
          this.password
        );
        this.step = 3;
      } catch (error) {
        this.message = error.response?.data?.message || "Произошла ошибка";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.flex-with-image {
  border-radius: 30px !important;
  width: 600px;
  height: 550px;
  background-image: url("@/assets/login_page_background.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: #23919e !important;
}
.v-stepper {
  background-color: transparent !important;
  box-shadow: none;
}
</style>
